module.exports = __webpack_public_path__ + "eebdd663b6d3f555c499996006fe4db4.png";